export const LOAD_SEASONS = 'load_seasons';
export const SEASONS_LOADED = 'set_loaded_seasons';
export const SEASONS_FAILED = 'seasons_sync_error';
export const RESET_SEASONS = 'reset_seasons';
export const LOADING_METADATA = 'loading_metadata';
export const METADATA_LOADED = 'metadata_loaded';
export const METADATA_FAILED = 'metadata_failed';
